<template>
<section class="video-list-preview">
	<div class="container">
		<div class="video-row">
			<div class="video-wrapper">
				<iframe src="https://www.youtube.com/embed/K3TUW3shO-A?si=ngxdK6q12wIuI0cE&amp;start=85" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
			<div class="video-wrapper">
				<iframe src="https://www.youtube.com/embed/ywYgEuQ9pNE?si=4aRJsE31ub0ZgxHY&amp;start=258" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
			<div class="video-wrapper">
				<iframe src="https://www.youtube.com/embed/waq1ne95tGw?si=loAFmVkHZ7sd2dll&amp;start=55" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
		</div>
		<div class="button-wrapper">
			<a href="https://www.youtube.com/dungeonfog" target="_blank" class="button"><i class="icon icon_play_video"></i>watch more</a>
		</div>
	</div>
</section>
</template>
<script>
export default {
	name: 'SectionVideoList',
}
</script>
